// Returns url query for provided path.
const getQueryParams = (path, key) => {
  var q = path.match(new RegExp('[?&]' + key + '=([^&#]*)'));
  return q && q[1];
};

export default getQueryParams;
